import styled from 'styled-components';
import { AssignmentListItemComponent } from './assignment-list-item.component';
import { getSize } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
export var assignments = [{
  id: '585030',
  title: 'Introduction to Algebra',
  type: 'Practice',
  status: 'Ongoing',
  submissions: 1,
  duration: '30 Minutes',
  startTime: 'No date set',
  endTime: 'N/A'
}, {
  id: '404739',
  title: 'Linear Equations Practice',
  type: 'Practice',
  status: 'Score Published',
  submissions: 28,
  duration: '45 Mins',
  startTime: '01/10/25 09:00',
  endTime: '02/10/25 18:00'
}, {
  id: '910740',
  title: 'Geometry Basics',
  type: 'Practice',
  status: 'Ended',
  submissions: 25,
  duration: '60 Mins',
  startTime: '01/10/25 09:00',
  endTime: '05/10/25 23:59'
}];
var CardList = styled.div.withConfig({
  displayName: "assignment-listcomponent__CardList",
  componentId: "sc-e7yeti-0"
})(["display:flex;flex-direction:column;gap:", ";"], getSize('padding16')); //TODO: Replace hardcoded text with translation props

export var AssignmentListComponent = function AssignmentListComponent(_ref) {
  var assignments = _ref.assignments,
      tableAssignmentTranslation = _ref.tableAssignmentTranslation,
      onShareAssignment = _ref.onShareAssignment,
      navigateToAssignmentDetail = _ref.navigateToAssignmentDetail;
  return /*#__PURE__*/_jsx(CardList, {
    children: assignments.map(function (assignment) {
      return /*#__PURE__*/_jsx(AssignmentListItemComponent, {
        assignment: assignment,
        tableAssignmentTranslation: tableAssignmentTranslation,
        onShareAssignment: onShareAssignment,
        navigateToAssignmentDetail: navigateToAssignmentDetail
      }, assignment.id.toValue());
    })
  });
};